import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=7608d7b6&"
import script from "./OrderForm.js?vue&type=script&lang=js&"
export * from "./OrderForm.js?vue&type=script&lang=js&"
import style0 from "./OrderForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports